import { lazyLoad } from 'utils/loadable';

export const ReportingPage = lazyLoad(
  () => import('./index'),
  module => module.ReportingPage,
);
